import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { CddAchVolumesForm } from './CddAchVolumesForm';
import { useCddAchLogic } from './hooks/useCddAchLogic';

export const CddAchVolumes = () => {
  const { t } = useTranslation('cddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useCddAchLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('achVolumes.subtitle')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <CddAchVolumesForm
          contentKeys={{
            achIncomingQuestion: 'achVolumes.achIncomingQuestion',
            achOutgoingQuestion: 'achVolumes.achOutgoingQuestion',
          }}
        />
      </StepPageWrapper>
    </FormProvider>
  );
};
